import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';
import { NgZone } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

export const DowngradedAngularCoreModule = angular
  .module('downgraded-angular-core', [])
  .service('DomSanitizer', downgradeInjectable(DomSanitizer))
  .factory('NgZone', downgradeInjectable(NgZone)).name;
